// extracted by mini-css-extract-plugin
export default {"page":"page_page__V-NyJ","back-button":"page_back-button__+Em3e","heading":"page_heading__K-ln5","content":"page_content__N+UW7"};